module.exports = __webpack_public_path__ + "static/media/HTML.99f794cc.svg";